import React, { Component } from "react";
import classes from "./Faq.module.css";
import Appbar from "../../../components/appBar/appBar";
import Footer from "../../../components/footer/footer";
import Button from "@material-ui/core/Button";
import Modal from "react-bootstrap/Modal";

class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredId: null,
      loadingId: null,
      videoModalShow: false,
      activeBlobUrl: "",
      faqItems: [
        {
          id: 1,
          title: "How To - Connect Zoho Books Integration (Video)",
          videoUrl:
            "https://storcicwsprod001.blob.core.windows.net/26as-assets/Zoho%20Books%20Integration%20Video.mp4",
          description:
            "Set up and connect your Zoho Books account to the 26AS module in just 2 minutes. Automatically sync customer records, invoices, and collections—quick and seamless.",
        },
        {
          id: 2,
          title: "How To - GSTR - 1 Filing",
          videoUrl:
            "https://storcicwsprod001.blob.core.windows.net/gst-assets/GSTR-1%20Filing%20Video.mp4",
          description:
            "Learn how to selectively include, update, or exclude specific invoices and HSN details while filing your GSTR-1.",
        },
          {
          id: 3,
          title: "GSTR - 1 Selective Invoice Filing User Manual",
          docUrl:
            "https://storcicwsprod001.blob.core.windows.net/gst-assets/GSTR-1%20Selective%20Invoice%20Filing%20-%20User%20Manual.docx",
          description:
            "Learn how to selectively include, update, or exclude specific invoices and HSN details, validate them, and submit your GSTR-1 filing directly to the GST Portal",
        },
        {
          id: 4,
          title: "26AS Module User Manual",
          docUrl:
            "https://storcicwsprod001.blob.core.windows.net/26as-assets/26AS%20Reconciliation.docx",
          description:
            "Comprehensive user manual covering every feature of the 26AS module—from setup and data uploads to reconciliation, manual pairing, notifications, and more.",
        },
        {
          id: 5,
          title: "How To - Get Started with 26AS Reconciliation (Video)",
          videoUrl:
            "https://storcicwsprod001.blob.core.windows.net/26as-assets/26AS%20Video%20Walkthrough.mp4",
          description:
            "Complete video walkthrough of the 26AS module—from login to final reconciliation. Learn how to set up, upload data, reconcile, and send customer notifications.",
        },
        {
          id: 6,
          title: "How To - Add Tally Connector (Video)",
          videoUrl:
            "https://storcicwsprod001.blob.core.windows.net/tallyintegrations/Tally%20Connector%20Video.mp4",
          description:
            "Complete video walkthrough of the Tally Connector.",
        },
      ],
    };
  }

  handleItemClick = async (item) => {
    if (item.videoUrl) {
      // Azure Blob Storage isn't honoring Range requests for this account
      // (returns full file with 200 instead of 206 Partial Content), which
      // is why seeking/fast-forwarding was unreliable when the browser
      // streamed directly from the blob URL. Fetching the whole file once
      // into a local blob avoids this entirely: once the browser has the
      // full video in memory, seeking is instant and needs no further
      // network requests to Azure at all.
      try {
        this.setState({ loadingId: item.id });
        const response = await fetch(item.videoUrl);
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        this.setState({ activeBlobUrl: blobUrl, videoModalShow: true });
      } catch (err) {
        console.error("Video load failed:", err);
        alert("Sorry, the video could not be loaded. Please try again.");
      } finally {
        this.setState({ loadingId: null });
      }
    } else if (item.docUrl) {
      const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
        item.docUrl
      )}&embedded=false`;
      window.open(googleViewerUrl, "_blank");
    }
  };

  closeVideoModal = () => {
    // Release the memory held by the blob URL once we're done with it
    if (this.state.activeBlobUrl) {
      window.URL.revokeObjectURL(this.state.activeBlobUrl);
    }
    this.setState({ videoModalShow: false, activeBlobUrl: "" });
  };

  backButton = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <>
        {/* Video Modal - plays from a local blob URL so seeking works
            instantly without depending on Azure Range request support */}
        <Modal
          show={this.state.videoModalShow}
          onHide={this.closeVideoModal}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Video Guide</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: 0, background: "#000" }}>
            {this.state.activeBlobUrl && (
              <video
                key={this.state.activeBlobUrl}
                width="100%"
                height="500px"
                controls
                autoPlay
                style={{ display: "block" }}
              >
                <source src={this.state.activeBlobUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button style={{ color: "red" }} onClick={this.closeVideoModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Appbar />
        <div className={classes.profileSection}>
          <div className={classes.PesonalInfo}>
            <div className={classes.ProfileHeader}>FAQ</div>
            <div className={classes.profileBody}>
              <ul>
                <li style={{ marginRight: "10px" }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={this.backButton}
                  >
                    Back
                  </Button>
                </li>
              </ul>
            </div>

            <div style={{ padding: "10px 20px" }}>
              {this.state.faqItems.map((item) => (
                <div
                  key={item.id}
                  onClick={() => this.handleItemClick(item)}
                  onMouseEnter={() => this.setState({ hoveredId: item.id })}
                  onMouseLeave={() => this.setState({ hoveredId: null })}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    padding: "14px 18px",
                    marginBottom: "12px",
                    borderRadius: "8px",
                    border: "1px solid #d0d8f0",
                    backgroundColor: "#f5f8ff",
                    cursor: "pointer",
                    transition: "box-shadow 0.2s",
                    boxShadow:
                      this.state.hoveredId === item.id
                        ? "0 2px 10px rgba(0,0,0,0.12)"
                        : "none",
                  }}
                >
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "50%",
                      backgroundColor: item.videoUrl ? "#e8f0fe" : "#fff3e0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px",
                      marginRight: "14px",
                      flexShrink: 0,
                    }}
                  >
                    {item.videoUrl ? "▶" : "📄"}
                  </div>

                  <div>
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "14px",
                        color: "#1a237e",
                        marginBottom: "4px",
                      }}
                    >
                      {item.title}
                      {item.videoUrl && (
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "#888",
                            marginLeft: "8px",
                          }}
                        >
                          {this.state.loadingId === item.id
                            ? "(loading video…)"
                            : ""}
                        </span>
                      )}
                    </div>

                    {this.state.hoveredId === item.id && (
                      <div
                        style={{
                          fontSize: "13px",
                          color: "#555",
                          lineHeight: "1.5",
                        }}
                      >
                        {item.description}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={classes.profileFooter}>
          <Footer />
        </div>
      </>
    );
  }
}

export default Faq;